import { SET_PAYMENT_FAILED_MODAL, CLEAR_PAYMENT_FAILED_MODAL, DISMISS_PAYMENT_FAILED_MODAL, LOGOUT } from '~/redux/actions/action-types';
import { resetPaymentFailedFlag } from '~/utils/request';

const initialState = {
  isOpen: false,
};

const paymentFailureReducer = (state = initialState, { type }) => {
  switch (type) {
    case SET_PAYMENT_FAILED_MODAL:
      return { ...state, isOpen: true };
    case CLEAR_PAYMENT_FAILED_MODAL:
      // Reset the module-level flag in request.js so the interceptor can
      // fire again on the next payment failure.
      resetPaymentFailedFlag();
      return { ...state, isOpen: false };
    case DISMISS_PAYMENT_FAILED_MODAL:
      // Close the modal but intentionally do NOT reset _paymentFailedDispatched.
      // This prevents the interceptor from reopening the modal on future responses
      // that still carry X-Payment-Failed-At. The server block stays active;
      // recovery is detected silently when a response arrives without the header.
      return { ...state, isOpen: false };
    case LOGOUT:
      resetPaymentFailedFlag();
      return initialState;
    default:
      return state;
  }
};

export { paymentFailureReducer };
